// extracted by mini-css-extract-plugin
export default {"container":"CardsButtons_container__l4xjx","first":"CardsButtons_first__+0nUN","second":"CardsButtons_second__8uA7d","with-photos":"CardsButtons_with-photos__zkzL9"};